<div class="modal-body height-600 width-700">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">{{getHeader()}}</h5>
    <div class="content modal-form">
      <form #inputForm="ngForm">
      <exg-textarea [maxlength]="512" [(ngModel)]="data.libComment" *ngIf="!data.isLibrary"
                    [caption]="getRessource('Comment')" id="area" name="area"></exg-textarea>
      </form>
      <p *ngIf="data.isLibrary">
        {{data.libComment}}
      </p>

    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="closeModal()">{{getGlobal('Close')}}</button>
      <button class="md-btn" *ngIf="!data.isLibrary" [disabled]="inputForm.invalid" (click)="saveInfo()">{{getGlobal('Save')}}</button>
    </div>
  </div>
</div>

